module.exports = __webpack_public_path__ + "img/ys3.a1a2e75f.png";